import VistaRegimental from '@mui/icons-material/RemoveRedEye';
import { makeObservable, observable } from 'mobx';
import { Filtro } from './Filtro';

export default class FiltroRetornoVistaRegimental extends Filtro {
    tipo = 'booleano';
    exibicao = 'checkbox';

    get label() {
        return 'Retorno de vista regimental';
    }

    getIconeFiltroRapido() {
        return <VistaRegimental />;
    }

    filtroRapido = {
        valor: true
    };

    constructor(props) {
        super(props);

        makeObservable(this, {
            filtroRapido: observable
        });
    }

    getValorOpcao(registro) {
        return (
            Array.isArray(registro?.informacoesAdicionais?.RetornoVistaRegimental) &&
            registro.informacoesAdicionais.RetornoVistaRegimental.length > 0
        );
    }

    getDescricao(valor) {
        return this.labelBooleanoSimNao(valor);
    }
}
